import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  isLoggedIn: false
};

export const textMessageReducer = createReducer(initialState, {
  [types.TEXTMSG_RESPONSE](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState
    };
  }
});
